var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1768 6.2198C11.1299 6.17294 11.0663 6.14661 11.0001 6.14661C10.9338 6.14661 10.8702 6.17294 10.8233 6.2198L8.00005 9.04305L5.1768 6.2198C5.12992 6.17294 5.06634 6.14661 5.00005 6.14661C4.93376 6.14661 4.87018 6.17294 4.8233 6.2198L4.4698 6.5733C4.42294 6.62018 4.39661 6.68376 4.39661 6.75005C4.39661 6.81634 4.42294 6.87992 4.4698 6.9268L7.8233 10.2803C7.87018 10.3272 7.93376 10.3535 8.00005 10.3535C8.06634 10.3535 8.12992 10.3272 8.1768 10.2803L11.5303 6.9268C11.5772 6.87992 11.6035 6.81634 11.6035 6.75005C11.6035 6.68376 11.5772 6.62018 11.5303 6.5733L11.1768 6.2198Z",
    fill: "#1E2DBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropdown);
export default __webpack_public_path__ + "static/media/arrowDropdown.4d4de05c84b2fcba39ef523bc42f09ed.svg";
export { ForwardRef as ReactComponent };